import { Server } from '@nextforce/api'

import getEnvironment from 'app/environment'
import { AnalyticsService, BaseAnalyticsEntity } from './types'

export class ServerAnalyticsService implements AnalyticsService {
  constructor(
    private server: Server,
    private analyticsEntity: BaseAnalyticsEntity
  ) {}

  async track(userId: string, eventType: string): Promise<void> {
    if (getEnvironment().name !== 'development') {
      return this.server.post('/v2/users/me/analytics', {
        user_id: Number(userId),
        event_type: eventType,
        ...this.analyticsEntity,
      })
    }
  }
}
